/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Header/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2LeftArrowLong from 'DesignSystem/Svgs/Tysiav2LeftArrowLong/index'
import Tysiav2RightArrowLong from 'DesignSystem/Svgs/Tysiav2RightArrowLong/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Header({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/ScheduleOptions/Content/DateSelect/Content/Header"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let tabSelectedLocationCurrentDateValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.location_current_date',
})
let dateSelectStartDateValueData = fromData.useDataValue({ viewPath,
context: 'date_select',
path: 'start_date',
})
let aggregateData = fromHelpers.isLeftArrowDisabled(tabSelectedLocationCurrentDateValueData, dateSelectStartDateValueData)
let onClick = fromHelpers.useOnClickArrowLeft({
  children,
  viewPath
  
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dateSelectStartDateValueData1 = fromData.useDataValue({ viewPath,
context: 'date_select',
path: 'start_date',
})
let constantData = 'MMMM yyyy'
let tabSelectedTimeZoneIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.time_zone_id',
})
let aggregateData1 = fromFormat.formatTzDate(dateSelectStartDateValueData1, constantData, tabSelectedTimeZoneIdValueData)
let onClick1 = fromHelpers.useOnClickArrowRight({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 weight="medium"
 color={dtColorsNeutral500}
 paddingBottom={dtSpaceXs}
 text="Select date"
/>
<div
  data-testid="Header.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 onClick={onClick}
 data="tab.selected.location_current_date"
 data="date_select.start_date"
 aggregate="helpers.js isLeftArrowDisabled"
 disabled={aggregateData}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
 type="primary"
>
{childProps => (
<Tysiav2LeftArrowLong
{...childProps}
  viewPath={`${viewPath}/Tysiav2LeftArrowLong`}
 width={dtSpaceS}
 height={dtSpaceS}
 fill2={dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="date_select.start_date"
 data="'MMMM yyyy'"
 data="tab.selected.time_zone_id"
 aggregate="/Data/format.js formatTzDate"
 text={aggregateData1}
/>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 onClick={onClick1}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
 type="primary"
>
{childProps => (
<Tysiav2RightArrowLong
{...childProps}
  viewPath={`${viewPath}/Tysiav2RightArrowLong`}
 width={dtSpaceS}
 height={dtSpaceS}
 fill2={dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
</div>
{children}
</React.Fragment>)
}